export const WALKX_TYPES = {
  APP: 1,
  WEB: 2,
};
